<template>
  <div v-if="!loading" class="status-table">
    <v-row>
      <v-col cols="8">
        <v-row v-for="row in infoRows" :key="row">
          <v-col cols="4" class="remove-space-bottom remove-space-right">
            <span class="title">
              {{row}}: 
            </span>
            
          </v-col>
          <v-col cols="8" class="remove-space-bottom remove-space-left">
            {{ returnRowInfo(row) }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <br>
    <v-row 
      class="control-bar"
      align="center"
    >
      <v-col cols="4">
        
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>

      <v-col cols="4">
        <v-chip-group v-model="selectedFilter" multiple active-class="third--text" class="ma-4">
          <v-chip v-for="tag in filters" :key="tag.val">{{ tag.text }}</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <div class="scrollable">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th 
                v-for="(item, index) in headers" 
                :key="index"
                class="text-left"
              >
                {{item.text}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in filteredItems"
              :key="index"
            > 
              <td>{{ item.vehicle_name }}</td>
              <td>
                <span :class="item.status_name">{{ statusMap(item.status_name) }}</span>
              </td>
              <td>{{ returnDescription(item.status_code) }}</td>
              <!-- <td>
                <v-icon 
                  :color="setIconColour(item)"
                  :disabled="setButtonState(item)"
                >
                  mdi-delete
                </v-icon>
              </td> -->
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <br>
    <v-row>
      <!-- <v-col cols="4">
        <v-btn text>
          cancel all pending updates
        </v-btn>
      </v-col> -->
      <v-spacer/>
      <v-col cols="4" class="text-right">
        <v-btn 
          text
          @click="close"
        >
          close
        </v-btn>
      </v-col>
    </v-row>
  </div>
  <div v-else class="loading">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </div>
</template>

<script>

import { Logger } from "aws-amplify"
const logger = new Logger("Status Table")

import { GetFirmwarePackageById } from "@/services/API.js"

export default {
  name: 'ConfigStatusTable',
  props: {
    items: {
      type: Array,
      required: true
    },
    job: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'Vehicle Name',
          value: 'vehicle_name'
        },
        { 
          text: "Status", 
          value: "" 
        },
        {
          text: 'Description',
          value: 'description'
        },
        // {
        //   text: "",
        //   value: ""
        // }
      ],
      search: '',
      selectedFilter: [],
      descriptionMap: {
        200: 'The update succeeded',
        304: 'The update was cancelled',
        404: 'File not found',
        406: 'Failed to authenticate the firmware',
        408: 'Too many retries',
        409: 'Out of memory error',
        410: 'The device was updated locally',
        500: 'The update was aborted',
        0: 'Pending'
      },
      infoRows: [
        'Organisation',
        'Device Model',
        'Firmware Version'
      ],
      info: {
        organisation: '',
        device_model: '',
        firmware_version: ''
      },
      orgId: '',
      firmwarePackage: {}
    }
  },
  computed: {
    filters() {
      return [
        { text: 'Done', val: 'done'},
        { text: 'Error', val: 'error'},
        { text: 'Pending', val: 'pending'}
      ]
    },
    filteredItems() {
      let results = this.items;
      let filters = this.selectedFilter.map(i => this.filters[i].val);

      if(this.search.length > 0) {
        results = this.items.filter(item => {
          return  item.vehicle_name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0;
        });
      }

      if (this.selectedFilter.length > 0) {
        results = this.items.filter(i => filters.includes(i.state.status));
      }

      return results
    },
  },
  mounted() {
    this.componentSetup();
  },
  methods: {
    componentSetup() {
      this.loading = true;

      // get firmware package info
      const orgId = this.job.org_id;
      const fmId = this.job.Tasks[0].context.firmware_id;

      GetFirmwarePackageById(orgId, fmId)
      .then(res => {
        const firmware = res.Firmware;

        this.firmwarePackage = firmware.find(firmware => firmware.firmware_id == fmId);


        // populate general info
        this.info.organisation = this.job.org;
        if (this.firmwarePackage) {
          this.info.device_model = this.firmwarePackage.model;
          this.info.firmware_version = this.firmwarePackage.version;
        } else {
          this.info.device_model = 'Unavailable';
          this.info.firmware_version = 'Unavailable';
        }
        

        this.loading = false;
      })
      .catch(err => {
        this.loading = false;
        logger.info('an error occurred : ', err);
      })
    },
    toggleConfig() {
      this.displayConfig = !this.displayConfig
    },
    statusMap(status) {
      let statusMap = {
        pending: 'Pending',
        error: 'Error',
        done: 'Done',
        success: 'Success',
        unknown: 'Unknown',
        cancelled: 'Cancelled'
      }

      return statusMap[status];
    },
    returnDescription(desc) {
      const isValid = Object.hasOwn(this.descriptionMap, desc);

      return isValid ? this.descriptionMap[desc] : 'Missing Description';
    },
    returnRowInfo(row) {
      const formatedRowKey = row.toLowerCase().replace(' ', '_');
      
      if (Object.hasOwn(this.info, formatedRowKey)) {
        return this.info[formatedRowKey];
      }
    },
    setIconColour(item) {
      const state = item.state.status;

      return state != 'pending' ? 'grey' : 'red';
    },
    setButtonState(item) {
      const state = item.state.status;

      return state != 'pending' ? true : false;
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="scss" scoped>
  .status-table {
    padding: 1em;
    // margin: 0;
    // border: thin solid rgba(0, 0, 0, 0.12);
    overflow: hidden;

    .title {
      color: #0f74bb;
      padding-left: 1em;
      font-size: 0.875rem !important;
    }
    .remove-space-bottom {
      padding-bottom: 0;
    }
    .remove-space-left {
      padding-left: 0;
    }
    .remove-space-right {
      padding-right: 0;
    }
    .center-contents {
      text-align: center;
    }

    .control-bar {
      padding-left: 1em;
    }
    
    .scrollable {
      overflow:hidden;
      overflow-y: scroll;
      height: 500px;
    }


    .pending {
      color: #ff9800;
    }

    .error {
      color: red;
      background-color: initial !important;
    }

    .cancelled {
      color: red;
      background-color: initial !important;
    }

    .done {
      color: #5cb860;
    }

    .success {
      color: #5cb860;
      background-color: initial !important;
    }

    .unknown {
      color: grey;
    }
  }

  .loading {
    padding: 2em;
    text-align: center;
  }
</style>